"use strict";

angular.module("vendor")
.component("productViewDetailedListing", {
    templateUrl: require("./product-view-detailed-listing.component.html"),
    controller: ProductListingController,
    controllerAs: "productListingCtrl"
});


function ProductListingController(
    $scope, $state, $stateParams, Language, ProductService, StateExtensionService, UserService
) {
    Language.initializeScope($scope, "language", "locale");
    $scope.pagination = {};
    $scope.params = angular.extend({}, $stateParams);

    $scope.productTypes = ProductService.getProductTypes();
    $scope.$on("LanguageChanged", function(obj, locale, short_code) {
        $scope.productTypes = ProductService.getProductTypes();
    });

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user && user.vendor) {
            $scope.allowProductVariants = user.vendor.allow_product_variants;
        }
    });

    this.seeDetails = function(id) {
        $state.go("productEdit", {id: id});
    };

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        query();
    };

    function query() {
        ProductService.query($scope.params).$promise.then(function(data) {
            $scope.pagination = data.pagination;
            $scope.products = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    }

    query();
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/detailed/product-view-detailed-listing.component.js
// module id = 919
// module chunks = 0